// KD-3643 — a trip must not be bookable while one of its products cannot be
// sold. Only the day that ran the pricing or availability request knows that,
// so each product instance reports its verdict up to the frame and the footer
// action reads the verdicts back.
//
// Three verdicts: nothing to report, a verdict not settled yet (the request is
// still in flight — blocking, but there is nothing to explain to the user), and
// a product that plainly cannot be booked.
export const PRODUCT_AVAILABILITY = {
  PENDING: 'pending',
  UNAVAILABLE: 'unavailable',
};

// Verdicts are keyed by the first day of the instance — a repeated program or a
// consecutive hotel stay is judged once, not once per day it spans — and only
// the day that owns that key ever writes it. A day that also reported would
// clear the key on the way out and let an unbookable trip through (the very bug
// this file exists for).
export const setProductAvailability = (setRegistry, key, status) =>
  setRegistry(previous => {
    if (!status) {
      if (!previous[key]) {
        return previous;
      }

      const next = { ...previous };
      delete next[key];
      return next;
    }

    return previous[key] === status ? previous : { ...previous, [key]: status };
  });

export const hasProductStatus = (registry, status) =>
  Object.values(registry).includes(status);
